import React from "react";
import RegistrationForm from "../Home/RegistrationForm";
import { Typography } from "antd";
import { NavLink } from "react-router-dom";
import LogoPng from '../../assets/logo.png'

const { Text } = Typography;

export default function Signup() {
  return (
    <section className="registeratoin-bg py-8 h-screen overflow-auto w-full flex flex-col gap-3 justify-center items-center bg-slate-900">
      <div className="bg-overlay-gradient"></div>
      
      <div className="relative z-10 flex flex-col gap-3 justify-center items-center h-full">

      <img src={LogoPng} className="w-52" alt="" />
      <RegistrationForm />
      <Text className="text-sm text-white">
        Have an account?{" "}
        <NavLink to="/login" className="!underline text-blue-600">
          Login
        </NavLink>
      </Text>
      </div>

    </section>
  );
}
